export default {
      id: "no-results-usage",
      viewBox: "0 0 166 136",
      url: __webpack_public_path__ + "sprite.svg#no-results",
      toString: function () {
        return this.url;
      }
    }